import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";

@autoinject
export class DialogAddPeopleToThisConversation {

    onProceed: () => Promise<void>;

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService) { 
    }

    activate(model: { onProceed: () => Promise<void> }) {
        this.onProceed = model.onProceed;
    }

    close() {
        this.dialogClientService.hide();
    }

    async confirm() {
        try {
            if (this.onProceed) await this.onProceed();
            this.dialogClientService.hide();
        } catch (error) {
            this.notificationClientService.show("Error", "An error occurred while marking the thread as completed.", NotificationType.Error);
        }
    }
}